import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { extractDate } from "../../Components/Functions/date.fun";
import { FcInspection } from "react-icons/fc";

const ShowFeedback = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/employee/view-employeefeedback/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting employee feedback!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleMarkAsRead = () => {
    setLoading(true);
    performRequest("PATCH", `/employee/edit-employeefeedback/${id}`, {
      markAsRead: true,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Feedback marked as read!");
          navigate(`/employee-feedbacks`);
        } else {
          Toast("error", "Error while uploading data");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcInspection className="fs-2 me-1" />
                  Employee Feedback
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4 ">
                <div className="btn-list justify-content-end">
                  <button
                    className="btn btn-primary d-none d-sm-block"
                    onClick={handleMarkAsRead}
                    disabled={data?.markAsRead}
                  >
                    MARK AS READ
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Employee Feedback</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Feedback type:
                  </label>
                  <div className="w-100 col">{data?.feedbackType || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Feedback Description :
                  </label>
                  <div className="w-100 col">{data?.feedback || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Date :</label>
                  <div className="w-100 col">
                    {extractDate(data.createdAt) || "N/A"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ShowFeedback;
